/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LabelWith2ValuesValue
 */
export interface LabelWith2ValuesValue {
    /**
     * 
     * @type {string}
     * @memberof LabelWith2ValuesValue
     */
    label: string;
    /**
     * 
     * @type {number}
     * @memberof LabelWith2ValuesValue
     */
    value1: number;
    /**
     * 
     * @type {number}
     * @memberof LabelWith2ValuesValue
     */
    value2: number;
}

/**
 * Check if a given object implements the LabelWith2ValuesValue interface.
 */
export function instanceOfLabelWith2ValuesValue(value: object): value is LabelWith2ValuesValue {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('value1' in value) || value['value1'] === undefined) return false;
    if (!('value2' in value) || value['value2'] === undefined) return false;
    return true;
}

export function LabelWith2ValuesValueFromJSON(json: any): LabelWith2ValuesValue {
    return LabelWith2ValuesValueFromJSONTyped(json, false);
}

export function LabelWith2ValuesValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): LabelWith2ValuesValue {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'value1': json['value1'],
        'value2': json['value2'],
    };
}

export function LabelWith2ValuesValueToJSON(value?: LabelWith2ValuesValue | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'value1': value['value1'],
        'value2': value['value2'],
    };
}

